import * as React from "react";

import { ProductType } from "./Chapters";

export default ({ key, method, storeName }) => {
  switch (key) {
    default:
      return <ProductType method={method} storeName={storeName} />;
  }
};
